import { hashSeed } from '@/lib/hash';

/**
 * The deterministic world clock. Wall-clock UTC drives the world.
 * For any time-keyed event, derive a seed via this helper so all players
 * see the same content at the same moment.
 *
 * See ENGINE.md §Time Architecture.
 */

export function now(): number {
  return Date.now();
}

/**
 * Returns a deterministic seed for `key` at the bucket containing `time`.
 * intervalMs defines the bucket size (e.g., 60_000 for 1-minute buckets).
 */
export function seedFor(key: string, time: number, intervalMs: number): number {
  const tick = Math.floor(time / intervalMs);
  return hashSeed(key, tick);
}
